import axios from 'axios';
import config from '../config';
import { handleServiceResponse } from '../hof/handleServiceResponse';

export class Domains {
    static list = async () => {

        return await handleServiceResponse(async () => {
            const options = {
                url: config.API_ADDR + '/domains',
                method: 'GET'
            };
            const { data } = await axios(options)
            return data;
        });
    }

    static search = async (keyword) => {
        return await handleServiceResponse(async () => {
            const {data} = await axios.post(`${config.API_ADDR}/domains/search`, {keyword});
            return data;
        })
    }

    static reserve = async (domain) => {
        return await handleServiceResponse(async () => {
            const {data} = await axios.post(`${config.API_ADDR}/domains/reserve`, {domain: domain});
            return data;
        })
    }

    static cancelReservation = async (id) => {
        return await handleServiceResponse( async () => {
            const {data} = await axios.delete(`${config.API_ADDR}/domains/${id}`);
            return data;
        })
    }

}
